import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy, AfterViewInit,ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { FirebaseMessage } from './../../services/firebasemessages';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';

import {NgxImageCompressService} from 'ngx-image-compress';
import { Ng2ImgMaxService } from 'ng2-img-max';



@Component({
  selector: 'app-add-firebase-messages',
  templateUrl: './add-firebase-messages.component.html',
  styleUrls: ['./add-firebase-messages.component.scss']
})
export class AddFirebaseMessagesComponent implements OnInit, OnDestroy {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isSlide: boolean = false;
  submitted: boolean = false;
  startDateValue: Date;
  fileHolder: File | null;
  endDateValue: Date;
  firebaseForm: FormGroup;
  firebaseMessagesList: any;
  isOpenModal = false;
  today: string;
  @ViewChild("fileInput") fileInput;

  imgResultBeforeCompress:string;
  imgResultAfterCompress:string;
  uploadedImage: any;



  constructor(private router: Router, private httpClient: HttpClient, private cd: ChangeDetectorRef, private fb: FormBuilder, config: NgbDatepickerConfig, private firebaseMessage: FirebaseMessage,private imageCompress: NgxImageCompressService, private ng2ImgMax: Ng2ImgMaxService) {
    this.today = new Date().toISOString();
    this.startDateValue = new Date();
    this.endDateValue = new Date();
    this.firebaseForm = this.fb.group({
      title: ['', [Validators.required]],
      description: ['', [Validators.required]],
      validFrom: [this.startDateValue, [Validators.required]],
      validTill: [this.endDateValue, [Validators.required]],
      file: [null],
      appliedForAll: [true, [Validators.required]],
      messageType: [true, [Validators.required]],
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  ngOnInit() {
    this.getAllMessages();
  }
  reset() {
    this.firebaseForm.reset();
    this.submitted = false;
    this.firebaseForm.patchValue({
      validFrom: new Date(),
      validTill: new Date(),
      appliedForAll: true,
      messageType: true,
    });
    
  }

  

  openModal() {
    this.isOpenModal = !this.isOpenModal;
  }
  getAllMessages() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    let data = {
      "token": loginUser.token
    }

    let body = JSON.stringify(data);
    this.httpClient.post(environment.apiURL + "/api/getAllFirebaseMessage", body)
      .subscribe(data => {
        if (data['returnCode'] == 0) {
          this.firebaseMessagesList = data['response'];
          console.log('this.firebaseMessagesList ', this.firebaseMessagesList);
          // Calling the DT trigger to manually render the table
          this.dtTrigger.next();
        }
      });
  }
  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }
  }
  get f() { return this.firebaseForm.controls; }
  onFileSelect(event) {
    debugger
    let reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.firebaseForm.patchValue({
          file: reader.result
        });
        this.cd.markForCheck();

      };
    }
  }

  
compressFile(image: any) {
  this.ng2ImgMax.resizeImage(image, 100, 100).subscribe(
    result => {
      console.log('result ', result);
      this.uploadedImage = this.blobToFile(result,"userfile");
      console.log('this.uploadedImage ', this.uploadedImage);
      //return this.uploadedImage;
    },
    error => {
      console.log('😢 Oh no!', error);
    }
  );
}

resizeAndCompress(){
  this.imageCompress.uploadFile().then(({image, orientation}) => {
    
    this.imgResultBeforeCompress = image;
    console.log('Size in bytes was:', this.imageCompress.byteCount(image));
    
    this.imageCompress.compressFile(image, orientation, 20, 20).then(
      result => {
        this.imgResultAfterCompress = result;
        console.log('Size in bytes is now:', this.imageCompress.byteCount(result));
        console.log('file :', result);
      }
    );
    
  });
  
}

public blobToFile = (theBlob: Blob, fileName:string): File => {
  var b: any = theBlob;
  //A Blob() is almost a File() - it's just missing the two properties below which we will add
  b.lastModifiedDate = new Date();
  b.name = fileName;

  //Cast to a File() type
  return <File>theBlob;
}

reloadCurrentRoute() {
  let currentUrl = this.router.url;
  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
  });
}



 onSubmit() {
    debugger;
    let startDate = this.firebaseForm.value.validFrom;
    let endDate = this.firebaseForm.value.validTill;
    startDate = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate()
    endDate = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate();
    let fi = this.fileInput.nativeElement;
    const formData = new FormData();
    if (fi.files && fi.files[0]) {
        let fileToUpload = fi.files[0];
      //this.compressFile(fi.files[0]);
      
      formData.append('file', fileToUpload);
      //formData.append('files',this.uploadedImage);
    }
    this.submitted = true;
    formData.append('title', this.firebaseForm.get('title').value);
    formData.append('description', this.firebaseForm.get('description').value);
    formData.append('validFrom', startDate);
    formData.append('validTill', endDate);
    formData.append('appliedForAll', this.firebaseForm.get('appliedForAll').value);
    formData.append('messageType', this.firebaseForm.get('messageType').value);
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    formData.append('token', loginUser.token);
    this.firebaseMessage.saveMessage(formData).subscribe((data) => {
      if (data['returnCode'] === 0) {
        alert(data['returnMsg']);
        this.reset();
        this.isOpenModal = false;
        let messageObject = {
          "createddate": new Date(),
          "description": this.firebaseForm.get('messageType').value,
          "id": 300,
          "image": "https://s3.amazonaws.com/sasadoctorimages/profileImages/1614015443160.JPG",
          "isactive": true,
          "isallpatients": true,
          "isannouncement": true,
          "ismessagesent": false,
          "title": this.firebaseForm.get('title').value,
          "validfrom": startDate,
          "validtill": endDate
        }
        this.firebaseMessagesList.push(messageObject);
        // this.getAllMessages();
        this.reloadCurrentRoute();
        
      }
    }, (err) => {

    });
  }

  deleteMessage(id) {
    if (confirm("Are you sure to delete")) {
      this.firebaseMessage.deleteMessage(id).subscribe((data) => {
        if (data['returnCode'] === 0) {
          alert('Record deleted successfully.')
        }
      }, (err) => {
        console.log(err);
      });
    }
  }
  messageSend(id) {
    console.log('id ',id);
    this.firebaseMessage.messageSend(id).subscribe((data) => {
      console.log('data ', data);
      if (data['returnCode'] === 0) {
        alert('Message sent successfully.')
        this.getAllMessages();
      }
    }, (err) => {
      console.log(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/add-firebase-messages/add-firebase-messages.component.ts